import { render, staticRenderFns } from "./MembraneSample.vue?vue&type=template&id=489c7042&scoped=true&"
import script from "./MembraneSample.vue?vue&type=script&lang=js&"
export * from "./MembraneSample.vue?vue&type=script&lang=js&"
import style0 from "./MembraneSample.vue?vue&type=style&index=0&id=489c7042&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489c7042",
  null
  
)

export default component.exports